/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import TaxPersonalTable from "./components/table";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import form from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import ModalCommon from "components/Modal/Modal";
import ModalContent from "./components/modalContent";
import Actions from "./components/actions";
import Tabs from "./components/tabs";
import rangePlugin from "flatpickr/dist/plugins/rangePlugin";
import SelectField from "components/SelectField";
import TaxPersonalTable02 from "./components/table-2";
import Footer from "./components/footer";
import TaxPersonalTable03 from "./components/table-3";

const provinceOptions = [
  { value: "Cần Thơ", label: "Cần Thơ" },
  { value: "Cần Thơ 2", label: "Cần Thơ 2" },
  { value: "Cần Thơ 3", label: "Cần Thơ 3" },
  { value: "Cần Thơ 4", label: "Cần Thơ 4" },
];

export default function TaxProperty03() {
  const [open, setOpen] = React.useState(true);
  const [tab, setTab] = React.useState(0);
  const [pickAll, setPickAll] = React.useState(false);
  const [list, setList] = React.useState([
    { name: "01-1/PL-CNKD", checked: false, disabled: true },
  ]);
  const [count, setCount] = React.useState(28);

  const handleChangeCount = (number) => setCount(number);

  const { formId, formField } = form;
  const handleSubmit = async (values, action) => {
    console.log({ values });
  };

  const handleChangeSwitch = (name, checked) => {
    if (pickAll) return;
    setList((prev) =>
      prev.map((item) => {
        if (item.name === name) {
          return { ...item, checked };
        }
        return item;
      })
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!open && (
        <>
          <Tabs tab={tab} setTab={setTab} list={list} pickAll={pickAll} />
          <Actions
            list={list}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        </>
      )}
      <ModalCommon
        open={open}
        setOpen={setOpen}
        content={
          <ModalContent
            list={list}
            setList={setList}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        }
      >
        {tab === 0 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Báo cáo
              </Typography>
              <Typography variant="h4" textTransform="uppercase">
                Sử dụng hóa đơn (01/BC-SHHĐ-CNKD)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Fields
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <TaxPersonalTable
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    onChangeCount={handleChangeCount}
                    setFieldValue={setFieldValue}
                  />
                  <TaxPersonalTable02
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    onChangeCount={handleChangeCount}
                    setFieldValue={setFieldValue}
                  />
                  <TaxPersonalTable03
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    onChangeCount={handleChangeCount}
                    setFieldValue={setFieldValue}
                  />
                  <Footer
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                  />

                  <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
      </ModalCommon>
    </DashboardLayout>
  );
}

function Fields({ formData, setFieldValue }) {
  const { formField, values, errors, touched } = formData;
  const {
    firstTime,
    supplementaryForThe,
    taxCalculationPeriod,
    taxId,
    taxpayerName,

    checkbox1,
    checkbox2,
    field01a,
    field01b,
    field01c,
    field01d,
    checkbox3,
    checkbox4,
    checkbox5,
    checkbox6,
  } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox1.name} label={checkbox1.label} value={values.checkbox1} />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox2.name} label={checkbox2.label} value={values.checkbox2} />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox3.name} label={checkbox3.label} value={values.checkbox3} />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox4.name} label={checkbox4.label} value={values.checkbox4} />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox5.name} label={checkbox5.label} value={values.checkbox5} />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox6.name} label={checkbox6.label} value={values.checkbox6} />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={taxCalculationPeriod.name}
            label={taxCalculationPeriod.label}
            error={errors.taxCalculationPeriod && touched.taxCalculationPeriod}
            success={
              values.taxCalculationPeriod?.toString().length > 0 && !errors.taxCalculationPeriod
            }
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={field01a.name}
            label={field01a.label}
            value={values.field01a}
            error={errors.field01a && touched.field01a}
            success={values.field01a?.toString().length > 0 && !errors.field01a}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              plugins: [
                new rangePlugin({
                  shorthand: true,
                  theme: "light",
                  dateFormat: "d/m/Y",
                }),
              ],
              enableTime: false,
            }}
            name={field01b.name}
            label={field01b.label}
            error={errors.field01b && touched.field01b}
            success={values.field01b?.toString().length > 0 && !errors.field01b}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={field01c.name}
            label={field01c.label}
            error={errors.field01c && touched.field01c}
            success={values.field01c?.toString().length > 0 && !errors.field01c}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name="01d_quy"
            label="[01d] Quý"
            type="number"
            onChange={({ target: { value } }) => setFieldValue("01d_quy", +value)}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name="01d_nam"
            label="[01d] Năm"
            type="number"
            onChange={({ target: { value } }) => setFieldValue("01d_nam", +value)}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              plugins: [
                new rangePlugin({
                  shorthand: true,
                  theme: "light",
                  dateFormat: "d/m/Y",
                }),
              ],
              enableTime: false,
            }}
            name={field01d.name}
            label={field01d.label}
            error={errors.field01d && touched.field01d}
            success={values.field01d?.toString().length > 0 && !errors.field01d}
          />
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name={firstTime.name} label={firstTime.label} value={values.firstTime} />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={supplementaryForThe.name}
            label={supplementaryForThe.label}
            value={values.supplementaryForThe}
            error={errors.supplementaryForThe && touched.supplementaryForThe}
            success={
              values.supplementaryForThe?.toString().length > 0 && !errors.supplementaryForThe
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxpayerName.name}
            label={taxpayerName.label}
            value={values.taxpayerName}
            error={errors.taxpayerName && touched.taxpayerName}
            success={values.taxpayerName?.toString().length > 0 && !errors.taxpayerName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId.name}
            label={taxId.label}
            value={values.taxId}
            error={errors.taxId && touched.taxId}
            success={values.taxId?.toString().length > 0 && !errors.taxId}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
